import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setState("success"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="verify-email-page">
      <div className="w-full max-w-md bg-[#0a0a0a] border border-white/10 rounded-2xl p-10 text-center">
        {state === "loading" && (
          <>
            <div className="w-12 h-12 border-4 border-[#E50914] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <h1 className="text-2xl font-bold" style={{ fontFamily: "Outfit" }}>Verifying...</h1>
          </>
        )}
        {state === "success" && (
          <>
            <CheckCircle2 className="text-[#00C853] mx-auto mb-3" size={56} />
            <h1 className="text-3xl font-black mb-2" style={{ fontFamily: "Outfit" }}>Email verified!</h1>
            <p className="text-[#aaa] mb-6">Your account is now fully unlocked.</p>
            <Link to="/browse" className="btn-primary" data-testid="continue-btn">Continue to Djino Stream</Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="text-[#E50914] mx-auto mb-3" size={56} />
            <h1 className="text-3xl font-black mb-2" style={{ fontFamily: "Outfit" }}>Link invalid or expired</h1>
            <p className="text-[#aaa] mb-6">Please request a new verification email from your account.</p>
            <Link to="/login" className="btn-secondary">Back to login</Link>
          </>
        )}
      </div>
    </div>
  );
}
